<template>

    <div ref="documentContainer" class="content-with-sidebar-component agree-to-proceed">

        <div class="container">
            <div class="row">

                <!-- Body -->
                <div class="col-8 body policy-wrap">
                    <div v-if="selected_policy">
                        <transition name="fade" mode="out-in">
                            <div>
                                <h1>{{ policyAndAcceptanceHeading }}</h1>

                                <p>{{ policyAndAcceptanceDescription }}</p>

                                <hr>

                                <policy-component :policy="selected_policy" :declarationText="policyAndAcceptanceDeclarationText" @policyToggled="policiesAccepted"/>

                                <div class="next-policy" v-if="currentPolicyAccepted && !maxIndex">
                                    <a href="#" @click="nextPolicy">{{ policyAndAcceptanceProceedText }} <i class="icon-arrow-right"></i></a>
                                </div>
                            </div>
                        </transition>
                    </div>

                    <footer-text v-if="footerText" :footerText="footerText" />

                </div>

                <!-- Sidebar -->
                <div class="col-4 sidebar">
                    <div>

                      <sidebar-get-in-touch
                        :heading="sidebarsHeading"
                        :description="sidebarsDescription"
                        :emailAddress="sidebarsEmailAddress"
                        :phoneNumber="sidebarsPhoneNumber"
                    />

                        <h3>{{ sidebarPoliciesTitle }}</h3>
                        <p>{{ dynamicSidebarPoliciesDescription }}</p>

                        <b class="mb-4 d-block">{{ sidebarPoliciesSubHeading }}:</b>

                        <div v-for="quote_policy in policies"
                             :key="'quote_policy-' + quote_policy.quotePolicyID" class="checkbox">
                            <input type="checkbox" :name="quote_policy.policyNameSlug" :id="quote_policy.policyNameSlug"
                                   v-model="quote_policy.accepted" disabled>
                            <label :for="quote_policy.policyNameSlug">
                                <span
                                    class="policy-link"
                                    @click="selectPolicy(quote_policy)">
                                    Read and accept the {{ quote_policy.policyName }}
                                </span>
                            </label>
                        </div>
                    </div>
                </div>

            </div>
        </div>


    </div>

</template>

<script>
import {EventBus} from '@/event-bus.js';
import PolicyComponent from './policy-component';
import SidebarGetInTouch from "./sidebar-get-in-touch";
import FooterText from "./footer/footer-text";

export default {

    components: {
        FooterText,
        SidebarGetInTouch,
        PolicyComponent
    },

    props: [
        'session',
        'adminPortalData',
        'adminPortalPrimaryProduct'
    ],

    data: () => {
        return {
            policies: [],
            selected_policy: null,
            currentPolicyIndex: 0,
        }
    },

    mounted() {
        //this.$router.push({ name:'Your Profile' })
    },

    computed: {
        maxIndex(){
            return (this.currentPolicyIndex + 1 ) >= this.policies.length;
        },
        currentPolicyAccepted(){
            return this.selected_policy ? this.selected_policy.accepted : true;
        },
        allPoliciesAccepted(){
            let allAccepted = true;
            this.policies.forEach((policy) => {
                if (!policy.accepted){
                    allAccepted = false;
                }
            });
            return allAccepted;
        },
        policyAndAcceptanceDeclarationText() {
            return this.adminPortalPrimaryProduct.policy_and_acceptance_declaration_text;
        },
        policyAndAcceptanceDescription() {
            return this.adminPortalPrimaryProduct.policy_and_acceptance_description;
        },
        policyAndAcceptanceHeading() {
            return this.adminPortalPrimaryProduct.policy_and_acceptance_heading;
        },
        policyAndAcceptanceProceedText() {
            return this.adminPortalPrimaryProduct.policy_and_acceptance_proceed_text;
        },
        sidebarsDescription() {
            return this.adminPortalPrimaryProduct.sidebars_description;
        },
        sidebarsEmailAddress() {
            return this.adminPortalPrimaryProduct.sidebars_email_address;
        },
        sidebarsHeading() {
            return this.adminPortalPrimaryProduct.sidebars_heading;
        },
        sidebarsPhoneNumber() {
            return this.adminPortalPrimaryProduct.sidebars_phone_number;
        },
        sidebarPoliciesDescription() {
            return this.adminPortalData.content ? this.adminPortalData.content.global.sidebar_policies_description : '';
        },
        sidebarPoliciesSubHeading() {
            return this.adminPortalData.content ? this.adminPortalData.content.global.sidebar_policies_sub_heading : '';
        },
        sidebarPoliciesTitle() {
            return this.adminPortalData.content ? this.adminPortalData.content.global.sidebar_policies_title : '';
        },
        footerText() {
            return this.adminPortalData.content?.products?.ecoamaps
                && this.adminPortalData.content?.products?.ecoamaps[0]?.fca_requirement_and_content_fca_description_required
                && this.adminPortalData.content?.products?.ecoamaps[0]?.fca_requirement_and_content_fca_description
                && this.adminPortalData.content?.products?.ecoamaps[0]?.fca_description_required_on_policy_acceptance
                ? this.adminPortalData.content.products.ecoamaps[0].fca_requirement_and_content_fca_description
                : false;
        },
        dynamicSidebarPoliciesDescription() {
            return this.sidebarPoliciesDescription.replace('{POLICY_COUNT}', this.policies.length > 0 ? this.policies.length : 3);
        }
    },

    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.get();
        })
    },

    async beforeRouteLeave (to, from, next) {
        // check if the continue button has been clicked.
        // if it has, then make the request to accept the policies.
        if(to.name !== 'Login' && to.name !== 'Welcome Aboard') {
            EventBus.$emit('loadingTitle', 'Accepted Policies');
            EventBus.$emit('loading', true);

            // Only run if this policy is accepted, we're not at the last one and we're not redirecting from the current page
            if (this.currentPolicyAccepted && !this.allPoliciesAccepted) {
                this.nextPolicy();
                EventBus.$emit('loading', false);
                return false;
            }

            if (!this.currentPolicyAccepted){
                EventBus.$emit('loading', false);
                EventBus.$emit('showError', true);
                EventBus.$emit('errorTitle', 'Please accept this policy to continue');
                return false;
            }

            try {
              const response = await this.$http.post('/api/accept-policies', {accept: true});
              EventBus.$emit('loading', false);
              if (response.data.data.accepted) {
                next();
              }
            } catch (err) {
                EventBus.$emit('loading', false);
                let response = err.response;

                this.$notify({
                    group: 'notify',
                    type: 'error',
                    title: 'Error',
                    text: response.message
                });
                this.error = err.message.toString();
                this.$router.push({ name: response.redirect });
            }
        } else {
            next();
        }
    },

    methods: {
        nextPolicy() {
            if (!this.maxIndex){
                this.currentPolicyIndex++;
                this.selected_policy = this.policies[this.currentPolicyIndex];
            }
            this.scrollToTop();
        },
        selectPolicy(policy) {
            this.selected_policy = policy;
            this.scrollToTop();
        },
        scrollToTop() {
            this.$nextTick(() => {
                this.$refs.documentContainer.scrollTop = 0;
            });
        },
        policiesAccepted(value) {

            let accepted = collect(this.policies).where('accepted', false).count() === 0;

            let policiesAccepted = accepted && value.accepted;

            this.$emit('policiesAccepted', policiesAccepted);
        },
        get() {
            EventBus.$emit('loadingTitle', 'Fetching Policies');
            EventBus.$emit('loading', true);

            this.$http.get('/api/accept-policies')
                .then(response => {
                    EventBus.$emit('loading', false);
                    this.$parent.policiesAccepted = response.data.session.policiesAccepted;
                    this.policies = response.data.data;
                    this.selected_policy = this.policies[this.currentPolicyIndex];

                    let allAccepted = true;
                    this.policies.forEach(policy => {
                       if (!policy.accepted) {
                           allAccepted = false;
                       }
                    });

                    if (allAccepted) {
                        console.debug('All policies accepted, proceeding to next stage...')
                        this.$router.push({ name:'Your Dashboard' })
                    }
                })
                .catch(err => {
                    EventBus.$emit('loading', false);
                    let response = err.response;

                    this.$notify({
                        group: 'notify',
                        type: 'error',
                        title: 'Error',
                        text: response.message
                    });
                    this.error = err.message.toString();
                    this.$router.push({ name: response.redirect });
                });
        },

    }
}
</script>
